/*
 * FileType.ts
 */
export class FileType {
}
FileType.SPRITE_SHEET = "SpriteSheet";
FileType.SPINE = "Spine";
FileType.ATLAS = "Atlas";
FileType.FONT = "Font";
FileType.SOUND = "Sound";
FileType.VIDEO = "Video";
FileType.LANG = "Lang";
FileType.IMAGE = "Image";
FileType.FILE = "File";
/*
 * FileExtension.ts
 */
export class FileExtension {
}
FileExtension.PNG = ".png";
FileExtension.WEBP = ".webp";
FileExtension.JSON = ".json";
FileExtension.XML = ".xml";
FileExtension.ATLAS = ".atlas";
FileExtension.WEBM = ".webm";
FileExtension.MP4 = ".mp4";
//# sourceMappingURL=FileType.js.map